// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Role$ReactHooksTemplate = require("./role.res.js");
var User$ReactHooksTemplate = require("./user.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var DomainModel$ReactHooksTemplate = require("./domainModel.res.js");
var ShareDialog$ReactHooksTemplate = require("./ShareDialog.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var UserRoleItem$ReactHooksTemplate = require("./UserRoleItem.res.js");
var DataRestriction$ReactHooksTemplate = require("./dataRestriction.res.js");

function UserListItem(props) {
  var user = props.user;
  var match = React.useState(function (param) {
        return false;
      });
  var setShowShare = match[1];
  var match$1 = React.useState(function (param) {
        
      });
  var setLinkMode = match$1[1];
  var match$2 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var hasPermission = match$2[0];
  var email = User$ReactHooksTemplate.email(user);
  var roles = User$ReactHooksTemplate.roles(user);
  var active = User$ReactHooksTemplate.active(user);
  var lastSignInAt = User$ReactHooksTemplate.lastSignInAt(user);
  var dataRestrictions = User$ReactHooksTemplate.dataRestrictions(user);
  var activeText = active ? "Active" : "Inactive";
  var activeTextClass = active ? "text-teal-700" : "text-gray-500";
  var match$3 = User$ReactHooksTemplate.confirmed(user);
  var match$4 = match$3 !== undefined && match$3 ? [
      "Password Reset Link",
      "reset"
    ] : [
      "User Confirmation Link",
      "confirmation"
    ];
  var mode = match$4[1];
  return JsxRuntime.jsxs("tr", {
              children: [
                JsxRuntime.jsx("td", {
                      children: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, email),
                      className: "py-3 px-4 text-sm text-gray-900 font-medium truncate max-w-[220px]"
                    }),
                JsxRuntime.jsx("td", {
                      children: $$Array.of_list(List.map((function (role) {
                                  return JsxRuntime.jsx(UserRoleItem$ReactHooksTemplate.make, {
                                              role: role
                                            }, String(Role$ReactHooksTemplate.id(role)));
                                }), roles)),
                      className: "py-3 px-4 text-sm text-gray-700"
                    }),
                JsxRuntime.jsx("td", {
                      children: lastSignInAt !== undefined ? Caml_option.valFromOption(lastSignInAt).fromNow(false) : "-",
                      className: "py-3 px-4 text-sm text-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: activeText,
                      className: "py-3 px-4 text-sm font-semibold " + activeTextClass
                    }),
                JsxRuntime.jsx("td", {
                      children: $$Array.of_list(Belt_List.mapWithIndex(dataRestrictions, (function (i, x) {
                                  var match = DataRestriction$ReactHooksTemplate.value(x);
                                  return JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("span", {
                                                      children: DataField$ReactHooksTemplate.name(DataRestriction$ReactHooksTemplate.dataField(x)) + ":",
                                                      className: "font-semibold"
                                                    }),
                                                JsxRuntime.jsx("span", {
                                                      children: match ? List.fold_left((function (x, y) {
                                                                return y + ("," + x);
                                                              }), match.hd, match.tl) : "---",
                                                      className: "ml-1 text-gray-600"
                                                    })
                                              ],
                                              className: "flex flex-col bg-gray-100 text-gray-800 text-xs font-medium px-2 py-1 rounded-md mr-1 mb-1 border border-gray-200 shadow-sm",
                                              title: DataField$ReactHooksTemplate.name(DataRestriction$ReactHooksTemplate.dataField(x))
                                            }, String(i));
                                }))),
                      className: "py-3 px-4 text-sm text-gray-700"
                    }),
                JsxRuntime.jsxs("td", {
                      children: [
                        Curry._1(hasPermission, "UpdateUser") ? JsxRuntime.jsx("button", {
                                children: JsxRuntime.jsx("img", {
                                      className: "h-4 w-4",
                                      alt: "Edit",
                                      src: Image$ReactHooksTemplate.edit
                                    }),
                                className: "p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition",
                                onClick: props.handleEdit
                              }) : null,
                        Curry._1(hasPermission, "DeleteUser") ? JsxRuntime.jsx("button", {
                                children: JsxRuntime.jsx("img", {
                                      className: "h-4 w-4",
                                      alt: "Delete",
                                      src: Image$ReactHooksTemplate.trash
                                    }),
                                className: "p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition",
                                onClick: props.handleDelete
                              }) : null,
                        JsxRuntime.jsx("button", {
                              children: match$4[0],
                              className: " max-w-150-px px-3 py-1.5 text-sm font-medium rounded-md bg-blue-600 text-white hover:bg-blue-700 transition",
                              onClick: (function (param) {
                                  Curry._1(setShowShare, (function (param) {
                                          return true;
                                        }));
                                  Curry._1(setLinkMode, (function (param) {
                                          return mode;
                                        }));
                                })
                            }),
                        match[0] && match$1[0] !== undefined ? JsxRuntime.jsx(ShareDialog$ReactHooksTemplate.make, {
                                user: user,
                                mode: mode,
                                onClose: (function (param) {
                                    Curry._1(setShowShare, (function (param) {
                                            return false;
                                          }));
                                  })
                              }) : null
                      ],
                      className: "py-3 px-4 text-sm text-right flex items-center justify-end space-x-2"
                    })
              ],
              className: "hover:bg-gray-50 transition"
            });
}

var make = UserListItem;

exports.make = make;
/* react Not a pure module */
